import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12h5v8h4v-16h4v8h5","key":"svg-0"}]]

const IconWaveSquare = createReactComponent('outline', 'wave-square', 'WaveSquare', __iconNode);

export default IconWaveSquare;